import { OnboardingRequirements, OnboardingRequirementTypes } from '@btcdirect/shared/src/composables/api/user/types';

export function isRegistrationComplete(requirements: OnboardingRequirements) {
    return !requirements || !requirements.length || requirements.every(requirement => isPendingIdentityDocument(requirement));
}

export function isPendingIdentityDocument(requirement: OnboardingRequirementTypes): boolean {
    return requirement.name === 'identityDocument' && requirement.status === 'pending';
}
